import { render, staticRenderFns } from "./categories_info.vue?vue&type=template&id=4f6356b9&"
import script from "./categories_info.vue?vue&type=script&lang=js&"
export * from "./categories_info.vue?vue&type=script&lang=js&"
import style0 from "./categories_info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports